import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/t/$tenantId/admin/roles/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenantId/admin/roles/users',
      params: { tenantId: params.tenantId },
      replace: true,
    });
  },
});
